import { isEmpty, isPlainObject } from 'lodash'

// Drops what `isProposed` in data-change-requests treats as absent: undefined, '' and empty objects.
// Arrays pass through — recursing into one would turn it into an index-keyed object, and `tech` is a list.
export const removeEmpty = data =>
  Object.fromEntries(
    Object.entries(data)
      .map(([key, value]) => [key, isPlainObject(value) ? removeEmpty(value) : value])
      .filter(([, value]) => value !== undefined && value !== '' && !(isPlainObject(value) && isEmpty(value))),
  )
